import { h, Component } from 'preact'
import style from './styles/index.scss'

import Container from '../Container'
import History from './History'
import Message from './Message'
import Answer from './Answer'

const getRandom = () => Math.random() * 2000 + 1000

class ChatBot extends Component {
  state = {
    isTyping: true
  }

  stopTyping = () => {
    const {question, onReady, onMessage} = this.props
    this.setState({isTyping: false})
    onReady()
    onMessage(question.id)
  }

  componentDidMount() {
    setTimeout(this.stopTyping, 1500)
  }

  handleAnswer = (question, answer) => {
    const {onAnswer} = this.props

    this.setState({isTyping: true})
    setTimeout(this.stopTyping, getRandom())

    onAnswer(question, answer)
  }

  render({history, question, results, data, timestamps}, {isTyping}) {
    return (
      <div class={style.normal}>
        <Container class={style.inner}>
          <History messages={history} data={data} timestamps={timestamps} />
          {results ?
            <Message key="results" message={results} isTyping={isTyping} data={data} timestamp={timestamps[question.id]} />
            : <Message key={question.id} message={question.text} isTyping={isTyping} data={data} timestamp={timestamps[question.id]} />
          }
          {!results &&
            <Answer
              answers={question.answers}
              question={question.id}
              type={question.type}
              format={question.format || 'text'}
              placeholder={question.placeholder || ''}
              onAnswer={this.handleAnswer}
              isTyping={isTyping}
            />
          }
        </Container>
      </div>
    )
  }
}

export default ChatBot



// WEBPACK FOOTER //
// ./components/ChatBot/index.js